import ContentPreview from './ContentPreview.vue';
export default ContentPreview;
